var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemCommentIconStroke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.67,28a2,2,0,0,1-.79-.17A2,2,0,0,1,5.75,26l0-3.45a6.68,6.68,0,0,1-4.13-2.18A6.18,6.18,0,0,1,0,15.82v-9A6.71,6.71,0,0,1,6.61,0H21.39A6.71,6.71,0,0,1,28,6.78v9a6.85,6.85,0,0,1-.3,2,6.67,6.67,0,0,1-6.28,4.77H14.28L8.94,27.5A1.85,1.85,0,0,1,7.67,28ZM7.6,26Zm-.8-5.41h1l0,5.25,5.73-5.25h7.88A4.7,4.7,0,0,0,26,15.82v-9a4.66,4.66,0,0,0-4.59-4.71H6.61A4.66,4.66,0,0,0,2,6.78v9A4.1,4.1,0,0,0,3.16,19a4.79,4.79,0,0,0,3.07,1.53Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemCommentIconStroke);
export default __webpack_public_path__ + "static/media/item_comment_icon_stroke.f06f5de40ab9cd320204d2fa62291c81.svg";
export { ForwardRef as ReactComponent };